import ChannelService from "../../service/ChannelService";

// Canal de venda ScontiPoste: vitrine propria em /scontiposte, so produtos elegiveis e pagamento so com cartao
export const CHANNEL = {
  code: "scontiposte",
  path: "/scontiposte",
  partnerName: "ScontiPoste",
};

export const channelService = new ChannelService(CHANNEL.code);

export const channelUrl = (subpath = "") => `${CHANNEL.path}${subpath}`;
